import React from 'react';

const steps = [
  { number: 1, title: "Úvodní schůzka", description: "Nejprve se seznámíme a nastavíme společné cíle. Probereme Vaši aktuální situaci a plány do budoucna." },
  { number: 2, title: "Analýza", description: "Podrobně analyzuji Vaši finanční situaci a identifikuji klíčové body, na kterých můžeme stavět." },
  { number: 3, title: "Návrh řešení", description: "Představím Vám konkrétní řešení a produkty, které odpovídají Vašim potřebám a cílům." },
  { number: 4, title: "Implementace", description: "Společně se pustíme do realizace navržených řešení a zajistíme, aby vše proběhlo hladce." },
  { number: 5, title: "Dlouhodobá péče", description: "Pravidelně budeme revidovat a optimalizovat nastavený plán, aby byl vždy aktuální." },
];

export default function Spoluprace() {
  return (
    <section id="spoluprace" className="relative bg-light px-4 sm:px-6 lg:px-8 py-20 scroll-mt-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <h2 className="font-extrabold text-dark text-3xl sm:text-4xl">
            Jak probíhá spolupráce?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-secondary text-base sm:text-lg leading-relaxed">
Provedu vás krok za krokem celým procesem s důrazem na kvalitu a dosažení vašich finančních cílů.
          </p>
        </div>

        <div className="space-y-12 md:space-y-16">
          {steps.map((step) => {
            const isOdd = step.number % 2 !== 0;
            return (
              <div
                key={step.number}
                className={`group relative flex items-center lg:transition-transform duration-300 lg:hover:-translate-y-2
                  xl:flex-row ${isOdd ? 'xl:flex-row' : 'xl:flex-row-reverse'}`}
              >
                <div className="z-10 relative flex-shrink-0">
                  <div className="flex justify-center items-center bg-primary shadow-lg rounded-full w-14 h-14 font-semibold text-white text-xl lg:group-hover:scale-110 lg:transition-transform duration-300">
                    {step.number}
                  </div>
                </div>

                <div
                  className={`mt-4 xl:mt-0 z-0 bg-white border-l-4 border-transparent lg:group-hover:border-primary p-6 rounded-2xl shadow-md transition-shadow duration-300 lg:hover:shadow-xl max-w-lg
                    ${isOdd ? 'ml-6 md:ml-8 xl:ml-12' : 'ml-6 md:ml-8 xl:ml-0 xl:mr-12'} text-left`}
                >
                  <h3 className="font-semibold text-dark lg:group-hover:text-primary text-xl sm:text-2xl lg:transition-colors">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-secondary text-base sm:text-lg leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
